import React, { useState, useEffect } from "react";
import { Fab, IconButton, Container, Paper, Typography } from "@material-ui/core";
import AddPhotoAlternateIcon from "@material-ui/icons/AddPhotoAlternate";
import { useForm } from "react-hook-form";
import { useStyles } from "../../assets/styles";
import ButtonWithStyle from "../../HOCs/ButtonWithStyle/ButtonWithStyle";
import InputWithStyle from "../../HOCs/InputWithStyle/InputWithStyle";
import { connect } from "react-redux";
import { addRestaurant } from "../../actions/restaurants";

function AddStore({ addRestaurant, returnNav, data }) {
	const [background, setBackground] = useState("");
	const [banner, setBanner] = useState("");
	let defaultValues = {};
	if (data) {
		defaultValues = {
			color: data.color || "",
			name: data.name || "",
			subName: data.subName || "",
			phone: data.phone || "",
			path: data.path || "",
			tags: data.tags?.join(",") || "",
		};
	}

	useEffect(() => {
		if (data) {
			if (data.imgUrl) {
				setBackground(data.imgUrl);
			}
			if (data.bannerImgUrl) {
				setBanner(data.bannerImgUrl);
			}
		}
	}, [setBackground, setBanner, data]);

	const { register, handleSubmit } = useForm({ defaultValues });

	const handleImageSelector = (e, handler) => {
		const { files } = e.target;
		const image = files[0];
		const urlForImage = URL.createObjectURL(image);
		handler(urlForImage);
	};

	const onSubmit = (input) => {
		if (data) {
			addRestaurant({ ...data, ...input }, true);
		} else {
			addRestaurant(input);
		}
	};

	const classes = useStyles();
	return (
		<Container className={classes.root}>
			<Paper className={classes.paper}>
				<Typography variant="h6">Imagen del Restaurante</Typography>
				<form onSubmit={handleSubmit(onSubmit)}>
					<div
						style={{
							padding: "1em",
							backgroundImage: `url(${background})`,
							backgroundRepeat: "no-repeat",
							backgroundPosition: "center",
							margin: "1em 0",
						}}
					>
						<input
							accept="image/*"
							className={classes.inputFile}
							ref={register()}
							name="restaurantImg"
							id="restaurantImg"
							type="file"
							onChange={(e) => handleImageSelector(e, setBackground)}
						/>
						<Fab>
							<label htmlFor="restaurantImg">
								<IconButton color="primary" aria-label="upload picture" component="span">
									<AddPhotoAlternateIcon />
								</IconButton>
							</label>
						</Fab>
					</div>
					<Typography variant="h6">Banner</Typography>
					<div
						style={{
							padding: "1em",
							backgroundImage: `url(${banner})`,
							backgroundRepeat: "no-repeat",
							backgroundPosition: "center",
							margin: "1em 0",
						}}
					>
						<input
							accept="image/*"
							className={classes.inputFile}
							ref={register()}
							name="restaurantBannerImg"
							id="restaurantBannerImg"
							type="file"
							onChange={(e) => handleImageSelector(e, setBanner)}
						/>
						<Fab>
							<label htmlFor="restaurantBannerImg">
								<IconButton color="primary" aria-label="upload picture" component="span">
									<AddPhotoAlternateIcon />
								</IconButton>
							</label>
						</Fab>
					</div>
					<InputWithStyle fullWidth name="name" inputRef={register({ required: true })} label="Nombre de la tienda" />
					<InputWithStyle
						fullWidth
						name="phone"
						inputRef={register({ required: true })}
						label="Telefono"
						type="number"
					/>
					<InputWithStyle
						fullWidth
						name="path"
						inputRef={register({ required: true })}
						label="Ubicación de la tienda en base de datos"
						disabled={data ? true : false}
					/>
					<InputWithStyle fullWidth name="subName" inputRef={register({ required: true })} label="Subtítulo" />
					<InputWithStyle
						fullWidth
						name="tags"
						inputRef={register({ required: true })}
						label="Tags separados por coma"
					/>
					<InputWithStyle fullWidth name="color" inputRef={register({ required: true })} label="Color hex #ffffff" />
					<ButtonWithStyle type="submit">Agregar</ButtonWithStyle>
					<ButtonWithStyle onClick={returnNav}>Regresar</ButtonWithStyle>
				</form>
			</Paper>
		</Container>
	);
}

export default connect(null, { addRestaurant })(AddStore);
